import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'timeFormat' })
export class TimeFormatPipe implements PipeTransform {
  transform(value: number): string {
    const seconds = Math.floor(value);
    const years = Math.floor(seconds / (365 * 24 * 60 * 60));
    const remainingAfterYears = seconds % (365 * 24 * 60 * 60);
    const months = Math.floor(remainingAfterYears / (30 * 24 * 60 * 60));
    const remainingAfterMonths = remainingAfterYears % (30 * 24 * 60 * 60);
    const days = Math.floor(remainingAfterMonths / (24 * 60 * 60));
    const remainingAfterDays = remainingAfterMonths % (24 * 60 * 60);
    const hours = Math.floor(remainingAfterDays / (60 * 60));
    const remainingAfterHours = remainingAfterDays % (60 * 60);
    const minutes = Math.floor(remainingAfterHours / 60);
    const finalSeconds = remainingAfterHours % 60;

    const weeks = Math.floor(days / 7);
    const remainingDays = days % 7;

    let formattedTime = '';

    if (years > 0) {
      formattedTime += `${years}y `;
    }
    if (months > 0) {
      formattedTime += `${months}mo `;
    }
    if (weeks > 0) {
      formattedTime += `${weeks}w `;
    }
    if (remainingDays > 0) {
      formattedTime += `${remainingDays}d `;
    }
    if (hours > 0) {
      formattedTime += `${hours}h `;
    }
    if (minutes > 0) {
      formattedTime += `${minutes}m `;
    }
    if (finalSeconds > 0 || formattedTime === '') {
      formattedTime += `${finalSeconds}s`;
    }

    return formattedTime.trim();
  }
}
